import { ApolloClient, ApolloLink, HttpLink, HttpOptions, split } from '@apollo/client'
import { BatchHttpLink } from '@apollo/client/link/batch-http'
import cache from 'graphql/cache'

import { RequestListenerLink } from './RequestListenerLink'

const options: HttpOptions = {
  uri: '/api/graphql',
  credentials: 'same-origin', // send auth cookie with every request
}

const singleRequestLink = new HttpLink(options)
const batchLink = new BatchHttpLink(options)

const httpLink = split(
  ({ getContext }) => {
    return getContext().newRequest
  },
  singleRequestLink,
  batchLink
)

export const requestListener = new RequestListenerLink()

export const client = new ApolloClient({
  cache,
  link: ApolloLink.from([requestListener, httpLink]),
  name: 'PEC Web',
  version: process.env.REACT_APP_VERSION,
  assumeImmutableResults: true,
})

export default client
